import { Container, Typography } from '@mui/material';

const NotFound = () => {
  return (
    <Container maxWidth="sm">
      <Typography variant="h4" gutterBottom>
        404 - Page Not Found
      </Typography>
    </Container>
  );
};

export default NotFound;
